/**
 * Merge tags for verification request assignment (sent to the assigned verifier).
 * Second result set shape matches action-planning assignment / implementation assignment emails.
 */
export const CAPA_VERIFICATION_ASSIGNMENT_EMAIL_MERGE_TAGS = [
  { tag: "{{CapaNo}}", entityName: "CapaNo", description: "CAPA reference number" },
  { tag: "{{Title}}", entityName: "Title", description: "CAPA title" },
  { tag: "{{Type}}", entityName: "Type", description: "Fixed label for verification tasks" },
  {
    tag: "{{Description}}",
    entityName: "Description",
    description: "Verification instructions for the assignee (HTML)",
  },
  { tag: "{{OwnerName}}", entityName: "OwnerName", description: "Assigned verifier display name" },
  { tag: "{{DueDate}}", entityName: "DueDate", description: "Request due date (dd/mm/yyyy)" },
  {
    tag: "{{StartDate}}",
    entityName: "StartDate",
    description: "Usually same as due date for verification requests",
  },
  { tag: "{{EntityLabel}}", entityName: "EntityLabel", description: "Linked context label (if any)" },
  { tag: "{{EntityType}}", entityName: "EntityType", description: "Linked entity type (if any)" },
  {
    tag: "{{OrganizationName}}",
    entityName: "OrganizationName",
    description: "Organization name (when available)",
  },
  { tag: "{{CapaUrl}}", entityName: "CapaUrl", description: "Deep link to open the CAPA" },
];

/**
 * Notify CAPA owner when a verifier submits Effective / Not Effective.
 * Same tokens as implementation owner emails; {{Decision}} is the normalized outcome.
 */
export const CAPA_VERIFICATION_OWNER_OUTCOME_EMAIL_MERGE_TAGS = [
  ...CAPA_VERIFICATION_ASSIGNMENT_EMAIL_MERGE_TAGS.map((row) =>
    row.entityName === "OwnerName"
      ? {
          ...row,
          description: "CAPA owner display name (email recipient)",
        }
      : row,
  ),
  {
    tag: "{{TaskAssigneeName}}",
    entityName: "TaskAssigneeName",
    description: "Staff assigned as verifier",
  },
  {
    tag: "{{DecidedByName}}",
    entityName: "DecidedByName",
    description: "Staff who submitted the verification outcome",
  },
  { tag: "{{Decision}}", entityName: "Decision", description: "Effective or Not Effective" },
  {
    tag: "{{DecisionReason}}",
    entityName: "DecisionReason",
    description: "Verifier comments",
  },
  {
    tag: "{{PreviousStatus}}",
    entityName: "PreviousStatus",
    description: "Request status before submit (Pending)",
  },
  {
    tag: "{{NewStatus}}",
    entityName: "NewStatus",
    description: "Request status after submit (Submitted)",
  },
];
